import { cache } from '@/container/apollo-client/cache';
import { cacheMutateAllTypenames } from '@/graphql/cache/cache-mutations';
import { useSetDefaultChannelMutation } from '@/types/generated/graphql';
import { gql } from '@apollo/client';
import { notification } from 'antd';

const CHANNEL_KEY = 'ChannelUserWorkspace:';
const FRAGMENT_ASSIGN_CHANNEL = gql`
  fragment ChannelUserWorkspace on ChannelUserWorkspace {
    id
    isDefault
  }
`;

export function useSetAsDefault() {
  const [setAsDefault, { loading }] = useSetDefaultChannelMutation({
    onCompleted: (res) => {
      notification.success({ message: res?.setDefaultChannel?.message });

      cacheMutateAllTypenames(FRAGMENT_ASSIGN_CHANNEL, CHANNEL_KEY, (cacheId) => ({
        isDefault: cacheId === res?.setDefaultChannel?.data?.id + '',
      }));

      cache.modify({
        fields: {
          assignChannelsV2: () => {},
        },
      });
    },
    onError: (res) => {
      notification.error({ message: res?.message });
    },
  });

  function setAsDefaultHandler(channelId: number) {
    setAsDefault({
      variables: {
        channelId,
      },
    });
  }

  return {
    setAsDefault: setAsDefaultHandler,
    loading,
  };
}
